import { AxiosResponse } from 'axios';
import { apiCall, clearCachedGetRequests } from './BaseAction';
import {
  FilterProcessList,
  Process,
  ProcessCategories,
  ProcessImageUpload,
  ProcessList,
  TApiProcessCategory,
  TApiProcessEntity,
  TFilterProcessListAction,
  TGetProcess,
  TGetProcessCategories,
  TGetProcessList,
  TUploadProcessImage,
} from '../types/Process';
import { TApiEntityImage } from '../types/Equipment';
import { Dispatch } from 'redux';
import { TDispatch } from '../types/Thunk';


export const getCategories = () => {
  return apiCall<TGetProcessCategories, null, Array<TApiProcessCategory>>(
    ProcessCategories,
    'GET',
    '/processes/categories',
    true
  );
};

export const getProcessList = (categoryId?: number) => {
  return apiCall<TGetProcessList, null, Array<TApiProcessEntity>>(
    ProcessList,
    'GET',
    '/processes',
    true,
    null,
    { category: categoryId}
  );
};

export const getProcess = (processId: number) => {
  return apiCall<TGetProcess, null, TApiProcessEntity>(
    Process,
    'GET',
    `/processes/${processId}`,
    true
  );
};

export const uploadProcessImage = (processId: number, image: string) => {
  return async (
    dispatch: TDispatch<TUploadProcessImage>
  ): Promise<AxiosResponse<TApiEntityImage>> => {
    const response = await apiCall<
      TUploadProcessImage,
      { image: string },
      TApiEntityImage
    >(
      ProcessImageUpload,
      'POST',
      `/processes/${processId}/image`,
      true,
      { image }
    )(dispatch);

    await clearCachedGetRequests();

    return response;
  };
};

export const filterProcessList = (search: string) => {
  return (dispatch: Dispatch<TFilterProcessListAction>) => {
    dispatch({
      type: FilterProcessList.SUBMIT,
      payload: {search},
    });
  };
};